import { createContext, useContext, useEffect, useState } from "react";
import { LANGUAGES, TRANSLATIONS, DEFAULT_LANG, STORAGE_KEY } from "./translations";

const I18nCtx = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  t: (k) => k,
  languages: LANGUAGES,
});

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && TRANSLATIONS[saved]) return saved;
    } catch { /* ignore */ }
    return DEFAULT_LANG;
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (code) => {
    if (!TRANSLATIONS[code]) code = DEFAULT_LANG;
    setLangState(code);
    try { localStorage.setItem(STORAGE_KEY, code); } catch { /* ignore */ }
  };

  // Lookup with English fallback. Always returns a string, never undefined.
  const t = (key) => {
    return TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS[DEFAULT_LANG][key] ?? key;
  };

  return (
    <I18nCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </I18nCtx.Provider>
  );
}

export const useT = () => useContext(I18nCtx);
